import {
  customer_profile_overall,
  customer_profile_cluster,
  customer_profile_area,
  customer_profile_branch,
  customer_daily_profile_overall,
  customer_daily_profile_cluster,
  customer_daily_profile_area,
  customer_daily_profile_branch,
} from "../../services/reports/customer_profiling_service";
import { actionTypes } from "../action_types";

const createCustomerProfileAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    return fetchFunction(data).then((resp) => {
      if (resp.problem === null) {
        dispatch({
          type: actionType,
          payload: resp.data === null ? { customerProfiles: [] } : resp.data,
        });
      }
      return Promise.resolve(resp);
    });
  };

export const GetCustomerProfileOverall = createCustomerProfileAction(
  customer_profile_overall,
  actionTypes.REPORTS_CUSTOMERPROFILING_GET_OVERALL
);

export const GetCustomerProfileCluster = createCustomerProfileAction(
  customer_profile_cluster,
  actionTypes.REPORTS_CUSTOMERPROFILING_GET_CLUSTER
);

export const GetCustomerProfileArea = createCustomerProfileAction(
  customer_profile_area,
  actionTypes.REPORTS_CUSTOMERPROFILING_GET_AREA
);

export const GetCustomerProfileBranch = createCustomerProfileAction(
  customer_profile_branch,
  actionTypes.REPORTS_CUSTOMERPROFILING_GET_BRANCH
);

export const GetCustomerDailyProfileOverall = createCustomerProfileAction(
  customer_daily_profile_overall,
  actionTypes.REPORTS_DAILY_CUSTOMERPROFILING_GET_OVERALL
);

export const GetCustomerDailyProfileCluster = createCustomerProfileAction(
  customer_daily_profile_cluster,
  actionTypes.REPORTS_DAILY_CUSTOMERPROFILING_GET_CLUSTER
);

export const GetCustomerDailyProfileArea = createCustomerProfileAction(
  customer_daily_profile_area,
  actionTypes.REPORTS_DAILY_CUSTOMERPROFILING_GET_AREA
);

export const GetCustomerDailyProfileBranch = createCustomerProfileAction(
  customer_daily_profile_branch,
  actionTypes.REPORTS_DAILY_CUSTOMERPROFILING_GET_BRANCH
);
